'use strict';

module.exports = {
  template: require('./users.html'),
  controller: require('./users.controller'),
  controllerAs: 'vm',

  bindings: {
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/users/index.js
 ** module id = 141
 ** module chunks = 0
 **/